import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export const USER_TYPE_ADMIN = 'admin'
export const USER_TYPE_CUSTOMER = 'customer'

export interface IUser {
  id: string
  first_name?: string
  last_name?: string
  email: string
  phone?: string
  type: string
}

interface IAuthStore {
  user: IUser | null
  token: string | null
  role: string | undefined | null
  merchantId: string
  merchantName: string
  customerId: string | null
}

const initialState: IAuthStore = {
  user: null || JSON.parse(localStorage.getItem('user') as string),
  token: null || JSON.parse(localStorage.getItem('token') as string),
  role: null || JSON.parse(localStorage.getItem('role') as string),
  customerId: null || JSON.parse(localStorage.getItem('customerId') as string),
  merchantId: null || JSON.parse(localStorage.getItem('merchantId') as string),
  merchantName:
    null || JSON.parse(localStorage.getItem('merchantName') as string)
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (
      state,
      action: PayloadAction<{
        user: IUser | null
        token: string
        merchantId: string
        merchantName: string
        customerId: string
      }>
    ) => {
      state.user = action.payload.user
      state.token = action.payload.token
      state.role = action.payload.user?.type
      state.merchantId = action.payload.merchantId
      state.merchantName = action.payload.merchantName
      state.customerId = action.payload.customerId
      localStorage.setItem('user', JSON.stringify(action.payload.user))
      localStorage.setItem('token', JSON.stringify(action.payload.token))
      localStorage.setItem('role', JSON.stringify(action.payload.user?.type))
      localStorage.setItem('customerId', JSON.stringify(action.payload.customerId))
      localStorage.setItem(
        'merchantId',
        JSON.stringify(action.payload.merchantId)
      )
      localStorage.setItem(
        'merchantName',
        JSON.stringify(action.payload.merchantName)
      )
    },
    logout: (state) => {
      state.user = null
      state.token = null
      localStorage.removeItem('user')
      localStorage.removeItem('token')
      localStorage.removeItem('merchantId')
      localStorage.removeItem('merchantName')
      localStorage.removeItem('customerId')
    },
    updateUserFullName: (state, action: PayloadAction<string>) => {
      const currentUser: IUser = {...state.user} as IUser
      const newUser = {
        ...currentUser,
        first_name: action.payload
      }
      state.user = newUser
      localStorage.setItem('user', JSON.stringify(newUser))
    },
    saveMerchantId: (state, action: PayloadAction<string>) => {
      state.merchantId = action.payload
      localStorage.setItem('merchantId', JSON.stringify(action.payload))
    },
    saveMerchantName: (state, action: PayloadAction<string>) => {
      state.merchantName = action.payload
      localStorage.setItem('merchantName', JSON.stringify(action.payload))
    }
  }
})

export const { login, logout, saveMerchantId, saveMerchantName, updateUserFullName } =
  authSlice.actions

export default authSlice.reducer
